import React, { useContext, useEffect, useState } from 'react';
import ScorecardContext from '../../contexts/ScorecardContext';
import Inputs from '../Inputs';
import AnalyticsContext from '../../contexts/AnalyticsContext';

const getFuturePeriodsLabel = (numberOfFuturePeriods: number) => {
  if (numberOfFuturePeriods === 0) {
    return '';
  }
  if (numberOfFuturePeriods === 1) {
    return ' + next period';
  }
  return ` + next ${numberOfFuturePeriods}`;
};

// Picks how many past periods to show. Future periods (if configured) are
// always appended on the right.
const ScorecardPeriodsSelector = () => {
  const {
    selectedPeriods,
    pastPeriods,
    futurePeriods,
    setSelectedPeriods,
    scorecard,
  } = useContext(ScorecardContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const [selectedLabel, setSelectedLabel] = useState<string | undefined>();

  useEffect(() => {
    if (selectedPeriods.length === 0) {
      setSelectedLabel(undefined);
      return;
    }

    const numberOfSelectedFuturePeriods = selectedPeriods.filter((p) =>
      futurePeriods.includes(p),
    ).length;
    const numberOfSelectedPastPeriods =
      selectedPeriods.length - numberOfSelectedFuturePeriods;
    const newLabel = `Last ${numberOfSelectedPastPeriods} periods${getFuturePeriodsLabel(
      numberOfSelectedFuturePeriods,
    )}`;
    setSelectedLabel(newLabel);
  }, [futurePeriods, selectedPeriods]);

  useEffect(() => {
    const newOptions = [] as DropdownOption[];
    const futureLabel = getFuturePeriodsLabel(futurePeriods.length);
    for (let i = 0; i < pastPeriods.length; i++) {
      const option = {
        label: `${i === 0 ? `Last period` : `Last ${i + 1} periods`}${futureLabel}`,
        onSelected: () => {
          setSelectedPeriods([
            ...pastPeriods.slice(-(i + 1)),
            ...futurePeriods,
          ]);
          trackEvent('KPI List - Selected Periods Changed', {
            scorecardName: scorecard.title,
            scorecardId: scorecard.id,
          });
        },
      };
      newOptions.push(option);
    }

    setOptions(newOptions);
  }, [
    futurePeriods,
    pastPeriods,
    scorecard.id,
    scorecard.title,
    setSelectedPeriods,
    trackEvent,
  ]);

  return (
    <Inputs.Dropdown
      selectedLabel={selectedLabel}
      options={options}
      unsetWidth
    />
  );
};

export default ScorecardPeriodsSelector;
